import {Radio} from "@material-tailwind/react";
import {RadioButtonCheckedRounded} from "@mui/icons-material";

interface Props {
    label?: string;
    disabled?: boolean;
    value: boolean;
    setValue?: React.Dispatch<React.SetStateAction<boolean>>;
    event?: any;
    textSize?: string;
    onChange?: () => void;
}
export const CustomRadioButton = ({label, disabled, value, setValue, event, textSize, onChange}: Props) => {
    const onChangeHandler = () => {
        if (event) {
            event();
        } else {
            if (setValue) setValue((prevValue) => !prevValue);
            if (onChange) onChange();
        }
    }

    return (
        <div className={`flex items-center ${disabled ? 'pointer-events-none' : ''}`}>
            <Radio
                crossOrigin=''
                checked={value}
                onChange={onChangeHandler}
                className={`border-[2px] ${disabled ? 'pointer-events-none border-textCheckboxDisabled' : 'border-empColorPrimary'}`}
                icon={
                    <div
                        className={`bg-white rounded-[50%]`}
                    >
                        <RadioButtonCheckedRounded className={'bg-white text-empColorPrimary rounded-[50%]'}/>
                    </div>
                }
            />
            {label && <span className={`text-[${textSize ? textSize : '16px'}] font-semibold text-textCheckbox`}>{label}</span>}
        </div>
    );
}
